import { getConfigName } from "@helpers/funciones";
import { TerminosYCondicionesFinbra } from "../components/terminos_y_condiciones.tsx/TerminosYCondicionesFinbra";
import { Navigate } from "react-router-dom";
import { TerminosYCondicionesLendia } from "@components/terminos_y_condiciones.tsx/TerminosYCondicionesLendia";
import { TerminosYCondicionesAvanzaSolido } from "@components/terminos_y_condiciones.tsx/TerminosYCondicionesAvanzaSolido";

const domainMap: Record<string, React.FC> = {
  finbra: TerminosYCondicionesFinbra,
  avanza_solido: TerminosYCondicionesAvanzaSolido,
};

export const TerminosYcondiciones = () => {
  const configName = getConfigName(window.location.href);
  
  // Redirección inmediata para now_ports
  if (configName === 'now_ports') {
    window.location.href = "https://nowports.com/terminos-y-condiciones";
    return null;
  }
  
  const Component = domainMap[configName];

  if (!Component) {
    return <Navigate to="/" replace />;
  }

  return (
    <>
      <Component />
      <TerminosYCondicionesLendia />
    </>
  );
};
